import styled from 'styled-components';
import backgroundImage from '../../../assets/images/background.webp';

// HERO SECTION
export const HomeContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  height: 100vh;
  width: 100vw;
  background-image: url(${backgroundImage});
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
`;

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.5);
  width: 100%;
  padding: 50px 80px;
  gap: 60px;
  margin-top: 80px;

  @media (max-width: 840px) {
    flex-direction: column;
    align-items: center;
    padding: 40px 30px;
    gap: 30px;
    margin-top: 80px;
  }
`;

export const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;

  img {
    margin-bottom: 20px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const TitleHike = styled.h1`
  margin: 0;
  font-size: 3rem;
  font-weight: 900;
  letter-spacing: 0.25rem;
  color: black;
  line-height: 1.1;

  @media (max-width: 840px) {
    font-size: 2.4rem;
    letter-spacing: 0.2rem;
  }
`;

export const TitleMatters = styled.h1`
  margin: 0;
  font-size: 3rem;
  font-weight: 900;
  letter-spacing: 0.25rem;
  color: black;
  line-height: 1.1;

  @media (max-width: 840px) {
    font-size: 2.4rem;
    letter-spacing: 0.2rem;
  }
`;

export const DescriptionContainer = styled.div`
  max-width: 500px;
  line-height: 1.6em;
  letter-spacing: 0.02rem;
`;

export const IdeaTitle = styled.h2`
  color: black;
  font-size: 1.6rem;
  font-weight: 800;
  margin: 0 0 15px 0;
  text-align: left;

  @media (max-width: 840px) {
    font-size: 1.4rem;
    text-align: center;
  }
`;

export const IdeaContent = styled.p`
  color: rgba(0, 0, 0, 0.8);
  font-size: 0.95rem;
  font-weight: 400;
  line-height: 1.6em;
  margin: 0 0 20px 0;
  text-align: left;

  @media (max-width: 840px) {
    font-size: 0.9rem;
    text-align: center;
  }
`;

// SECTIONS
export const SectionContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 30px 60px 30px;
  max-width: 1200px;
  margin: 0 auto;

  @media (max-width: 840px) {
    padding: 15px 20px 50px 20px;
  }

  ${IdeaTitle} {
    text-align: center;
    color: #1a1a1a;
  }

  ${IdeaContent} {
    text-align: center;
    color: #333;
  }
`;

export const SectionDivider = styled.div`
  width: 100%;
  height: 2px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    #ccc 20%,
    #af9483 50%,
    #ccc 80%,
    transparent 100%
  );
  margin: 0;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 12px;
    height: 6px;
    background-color: #af9483;
    border-radius: 3px;
  }
`;

// CAROUSEL
export const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1000px;
  margin: 30px 0;
  position: relative;
  gap: 20px;
`;

interface CarouselCardProps {
  isCenter?: boolean;
}

export const CarouselCard = styled.div<CarouselCardProps>`
  background: white;
  border-radius: 12px;
  padding: ${(props) => (props.isCenter ? '40px' : '30px')};
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  min-height: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: ${(props) => (props.isCenter ? '1.1rem' : '0.95rem')};
  font-weight: ${(props) => (props.isCenter ? '600' : '400')};
  line-height: 1.5em;
  color: #333;
  flex: 1;
  transition: all 0.3s ease;
  width: 100%;

  @media (max-width: 840px) {
    padding: ${(props) => (props.isCenter ? '30px 25px' : '25px 20px')};
    font-size: ${(props) => (props.isCenter ? '1rem' : '0.9rem')};
    min-height: 160px;
    height: 160px;
  }
`;

interface CarouselButtonProps {
  position: 'left' | 'right';
}

export const CarouselButton = styled.button<CarouselButtonProps>`
  background: #af9483;
  color: white;
  border: none;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  font-size: 1.3rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #1a1a1a;
    transform: scale(1.1);
  }

  @media (max-width: 840px) {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
  }
`;

export const CarouselIndicators = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 20px;
`;

interface CarouselIndicatorProps {
  active: boolean;
}

export const CarouselIndicator = styled.button<CarouselIndicatorProps>`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: none;
  background: ${(props) => (props.active ? '#af9483' : '#ddd')};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #af9483;
    transform: scale(1.2);
  }
`;

// ICONS SECTION
export const IconSection = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-top: 30px;

  @media (max-width: 840px) {
    flex-direction: column;
    gap: 35px;
    align-items: center;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 280px;

  svg {
    color: #af9483;
    margin-bottom: 15px;
    transition: all 0.3s ease;
    width: 50px;
    height: 50px;
  }

  &:hover svg {
    color: #1a1a1a;
    transform: scale(1.1);
  }
`;

export const IconTitle = styled.h3`
  color: #1a1a1a;
  font-size: 1.2rem;
  font-weight: 700;
  margin: 0 0 12px 0;
`;

export const IconDescription = styled.p`
  color: #555;
  font-size: 0.9rem;
  line-height: 1.5em;
  margin: 0;
`;
